import Store                from "Dashboard/Core/Store";
import DateTime             from "Dashboard/Utils/DateTime";
import Utils                from "Dashboard/Utils/Utils";
import { News }             from "Utils/API";



// The initial State
const initialState = {
    loading    : true,
    error      : false,
    edition    : 0,
    canCreate  : false,
    canEdit    : false,
    canFilter  : false,
    canImport  : false,
    canExport  : false,
    list       : [],
    total      : 0,
    elem       : {},
    categories : [],
    statuses   : [],
    filters    : {
        search   : "",
        fromDate : "",
        toDate   : "",
    },
    sort       : {
        orderBy  : "publishTime",
        orderAsc : 0,
        page     : 0,
        amount   : 50,
    },
};



// The Actions
const actions = {
    /**
     * Starts the Loader
     * @param {Function} dispatch
     * @returns {Void}
     */
    startLoader(dispatch) {
        dispatch({ type : "NEWS_LOADING" });
    },

    /**
     * Fetches the News Entry List
     * @param {Function} dispatch
     * @param {Object=}  filters
     * @param {Object=}  sort
     * @returns {Promise}
     */
    async fetchList(dispatch, filters = {}, sort = {}) {
        const data   = await News.getAll({ ...filters, ...sort });
        data.filters = filters;
        data.sort    = sort;
        dispatch({ type : "NEWS_LIST", data });
    },

    /**
     * Fetches a single News Entry
     * @param {Function} dispatch
     * @param {Number}   newsID
     * @returns {Promise}
     */
    async fetchElem(dispatch, newsID) {
        const data = await News.getOne({ newsID });
        dispatch({ type : "NEWS_ELEM", data });
        return data;
    },

    /**
     * Fetches the News Entry Edit data
     * @param {Function} dispatch
     * @returns {Promise}
     */
    async fetchEditData(dispatch) {
        const data = await News.getEditData();
        dispatch({ type : "NEWS_EDIT", data });
    },

    /**
     * Edits/Creates a News Entry
     * @param {Function} dispatch
     * @param {Object}   data
     * @returns {Promise}
     */
    editElem(dispatch, data) {
        return News.edit(data);
    },

    /**
     * Deletes the News Entry
     * @param {Function} dispatch
     * @param {Number}   newsID
     * @returns {Promise}
     */
    deleteElem(dispatch, newsID) {
        return News.delete({ newsID });
    },
};



/**
 * Parses a single Element
 * @param {Object} elem
 * @returns {Object}
 */
function parseElem(elem) {
    elem.publishTimeDate = DateTime.formatDate(elem.publishTime, "dashes");
    elem.publishDate     = DateTime.formatDate(elem.publishTime, "dashesReverse");
    elem.showInHomeText  = Utils.toYesNo(elem.showInHome);
    elem.forNazarText    = Utils.toYesNo(elem.forNazar);
    elem.showBeforeText  = Utils.toYesNo(elem.showBefore);
    return elem;
}

/**
 * The Reducer
 * @param {Object=} state
 * @param {Object=} action
 * @returns {Object}
 */
const reducer = (state = initialState, action = {}) => {
    if (Utils.hasError(action, "NEWS_LIST", "NEWS_ELEM")) {
        return { ...state, loading : false, error : true };
    }

    switch (action.type) {
    case "NEWS_LOADING":
        return {
            ...state,
            loading    : true,
        };

    case "NEWS_LIST":
        return {
            ...state,
            loading    : false,
            error      : false,
            canCreate  : action.data.canCreate,
            canEdit    : action.data.canEdit,
            canFilter  : action.data.canFilter,
            canImport  : action.data.canImport,
            canExport  : action.data.canExport,
            list       : Utils.parseList(action.data.list, parseElem),
            total      : action.data.total,
            filters    : action.data.filters,
            sort       : action.data.sort,
        };

    case "NEWS_ELEM":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            elem       : parseElem(action.data.elem),
            categories : action.data.categories,
            statuses   : action.data.statuses,
        };

    case "NEWS_EDIT":
        return {
            ...state,
            error      : false,
            edition    : state.edition + 1,
            categories : action.data.categories,
            statuses   : action.data.statuses,
        };

    default:
        return state;
    }
};




// The public API
export default Store.createSlice(initialState, actions, reducer);
